import React from 'react'
import PropTypes from 'prop-types'
import { Toast, Typography } from '@chilecompra/react-kit/components'
import { Section } from './PartnershipCertificateDialog.styles'

/**
 * The information component.
 */
const Information = props => {
  const { error, isSTU, loading, oldCertificate } = props
  const message = () => {
    if (oldCertificate) {
      return 'La información desplegada presenta a los socios y accionistas principales con participación igual o superior al 10%'
    } else {
      return isSTU
        ? 'La información desplegada presenta a los socios y accionistas principales con participación igual o superior al 10% de las empresas proveedoras que son parte de esta unión temporal de proveedores.'
        : 'La información desplegada presenta a los socios y accionistas principales con participación igual o superior al 10% de la empresa proveedora.'
    }
  }

  return (
    <>
      {!error && !loading && (
        <Section margin="0 0 32px">
          <Toast>
            <Typography variant="body2">{message()}</Typography>
          </Toast>
        </Section>
      )}
    </>
  )
}

Information.defaultProps = {
  error: false,
  loading: false,
  isSTU: false,
  oldCertificate: false
}

Information.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  isSTU: PropTypes.bool,
  oldCertificate: PropTypes.bool
}

export default Information
